import Button from '@berlitz/button'
import { H2 } from '@berlitz/globals'
import Select from '@components/Select'
import styled, { css } from 'styled-components'
import { BulletProp, StatusProp } from './interface'

export const Box = styled.div``

export const RecordWrapper = styled.div<{ isFlex?: boolean }>`
  min-width: 200px;
  display: flex;
  & > div {
  }

  ${({ isFlex }) =>
    isFlex &&
    css`
      padding-bottom: ${({ theme }) => theme.space.sm};
    `}
`

export const Label = styled.div<StatusProp>`
  ${({ theme, status }) =>
    status === 'Absent' &&
    css`
      color: ${theme.palette.blueGray60};
    `}
`

export const List = styled.ul<BulletProp & StatusProp>`
  list-style: none;

  ${({ showBullet, status }) =>
    showBullet &&
    status !== 'Absent' &&
    css`
      list-style: initial;
    `}
`

export const StyledH2 = styled(H2)`
  margin: 0;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
  }
`

export const StyledButton = styled(Button)`
  border: 2px solid ${({ theme }) => theme.colors.brandPrimary};
  padding: ${({ theme }) => `${theme.space.xs} ${theme.space.lg}`};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
  }

  outline: none;
`

export const OutlineButton = styled(Button)`
  padding: ${({ theme }) => `${theme.space.xs} ${theme.space.lg}`};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
    margin-bottom: ${({ theme }) => theme.space.sm};
  }

  outline: none;

  margin-right: ${({ theme }) => theme.space.sm};

  &:hover {
  }
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const SelectLevel = styled.div`
  margin-right: ${({ theme }) => theme.space.sm};
`

export const StyledSelect = styled(Select)`
  width: 100%;
`

export const SpeakingTitle = styled.div`
  padding-bottom: ${({ theme }) => theme.space.xs};
`

export const GradeLabel = styled.span<{ color?: string }>`
  background-color: ${({ color }) => color};
  padding: ${({ theme }) => theme.space.xxxs} ${({ theme }) => theme.space.xxs} 3px;
  color: ${({ theme }) => theme.palette.gray00};
  border-radius: ${({ theme }) => theme.radius.sm};
  font-size: ${({ theme }) => theme.fontSize.xxxs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`
